export default "__VITE_ASSET__jmTXwW7O__"